export const text = {
    uploading: `Uploading...`, // TODO: localize
};
